import { dataExport } from "./csvInput";

export async function init(input) {
    if (!input.weight || !input.height || !input.prefFit) {
        return undefined;
    }

    let adjustedWeight = parseInt(input.weight);
    if (input.prefFit === "Tæt") {
        adjustedWeight -= 5;
    } else if (input.prefFit === "Løst") {
        adjustedWeight += 5;
    }

    const sizesData = await dataExport();
    if (!sizesData) {
        return undefined;
    }

    const answer = sizesData.filter(row => row.height == input.height && row.weight == adjustedWeight);

    if (answer.length > 0) {
        const shirt = answer[0];
        const satisfaction = shirt.grade;
        const suggestionText = `Anbefaling: Pasform **${shirt.body_fit}** i størrelse **${shirt.size}**.`;
        const satisfactionText = `Sikkerhed: ${satisfaction}`;

        const val1 = Math.round(shirt.height_avg * 10) / 10;
        const val2 = Math.round(shirt.weight_avg * 10) / 10;


        return {
            suggestionText: suggestionText,
            satisfactionText: satisfactionText,
            height: val1,
            weight: val2,
            shirt: shirt
        }
    } else {
        return undefined;
    }
}
